import router from '../services/router_service';
import micController from '../controllers/mic_controller';

router.on('route:most-innovative-companies', micController);
